<template>
  <v-container grid-list-md pa-0 relative>
    <v-layout row wrap>
      <v-flex xs12 sm12>
        <v-card outlined class="primary--border">
          <v-card-title class="title">
            AS-OF Due Report
            <v-spacer></v-spacer>
            <print-buttons :passAuthToReport="true" v-if="downloadUrl && form.items.data.length"
              :downloadUrl="downloadUrl + `&filter_type=${this.report_type}&type=`" :pdf="true" :excel="true"
              labelPdf="Download Pdf" labelExcel="Download Excel"></print-buttons>
          </v-card-title>
          <v-card outlined>
            <v-card-title class="title mt-3">

              <v-flex xs2 sm2>
                <v-calendar-field id-val="cut_off_date" v-model="cutOffDate" label="As Of Date">
                </v-calendar-field>
              </v-flex>
              <v-flex xs2>
                <v-grade-field label="Select Grades" @selectedGrade="selectedGrade" v-model="gradeId"></v-grade-field>
              </v-flex>

              <v-flex xs2>
                <v-section-field v-model="sectionId" :grade-id="gradeId" label="Select Section"></v-section-field>
              </v-flex>
              <v-flex xs2 sm2>
                <v-select :disabled="!gradeId" :items="[
                  { value: 'all', text: 'All', disabled: true },
                  { value: 'left', text: 'Left Student', disabled: true },
                  { value: 'current', text: 'Current Student', disabled: false },
                ]" class="pa-0" label="Filter Type" v-model="report_type" outlined dense />
              </v-flex>

              <search-button :disabled="!gradeId" style="" permission="receipt-read" @action="get()">
                Search
              </search-button>
            </v-card-title>
            <div class="data-represent" style="margin-top: -10px" v-if="records.length">
              <div>
                <span class="d-error"></span> &nbsp;
                <small>
                  <strong>{{ totalSum.currency() }}</strong> Total Due</small>
              </div>
              <div>
                <span class="d-info"></span> &nbsp;
                <small>Total <strong>{{ records.length }}</strong> Records
                </small>
              </div>
            </div>
            <br />
          </v-card>
          <v-data-table :headers="headers" :items="records" hide-default-footer :options.sync="pagination"
            :footer-props="footerProps" :server-items-length="records.length" :loading="loading">
            <template v-slot:item="{ index, item }">
              <tr style="cursor: pointer">
                <td>{{ ++index }}</td>
                <td class="text-xs-left">
                  <strong>{{ item.full_name }}</strong>
                  <small style="
                      color: #777;
                      font-weight: bold;
                      display: block;
                      margin-top: -1px;
                    ">
                    {{ item.enroll_code }} &nbsp;&nbsp;&nbsp;

                  </small>
                </td>
                <td class="text-right">
                  {{ item.invoice_total.currency() }}
                </td>
                <td class="text-right">
                  <strong>{{ item.due_as_of ? item.due_as_of.currency() : '-' }}</strong>

                </td>
              </tr>
            </template>
            <template v-slot:body.append>

              <tr v-if="totalSum > 0">
                <td :colspan="headers.length - 2">
                  <strong>Total:</strong>
                </td>
                <td>
                  <strong>{{ totalSum.currency() }}</strong>
                </td>
                <td></td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>

import Form from "@/library/Form";

const NepaliDate = require("nepali-date-js");
const nd = new NepaliDate();
import Mixins from "@/library/Mixins";
import { v2Services } from "@/library/helpers";

export default {
  mixins: [Mixins],
  data: () => ({
    records: [],
    loading: false,
    form: new Form(
      {
        sod_date: nd.format("YYYY-MM-DD"),
      },
      ""
    ),
    pagination: {
      rowsPerPage: 100,
      descending: true,
    },
    frmDate: nd.getYear() + "-" + nd.getMonth().pad() + "-" + nd.getDate().pad(),
    cutOffDate: nd.format("YYYY-MM-DD"),
    gradeId: null,
    sectionId: "",
    grade: null,
    downloadUrl: "",
    totalSum: 0,
    headers: [
      { text: "#", align: "center", value: "id", width: 50, sortable: false },
      { text: "Student", align: "left", value: "student", sortable: false },
      { text: "Invoice Total", align: "right", value: "invoice_total", sortable: false },
      {
        text: "Due Amount",
        align: "right",
        value: "amount",
        width: 200,
        sortable: false,
      }
    ],
    report_type: 'current',
  }),
  mounted() {

  },

  methods: {
    selectedGrade(grade) {
      this.grade = grade;
      this.records = [];
      this.sectionId = "";
      this.totalSum = 0;
    },

    get() {
      if (!this.grade || !this.cutOffDate) return;

      if (!this.sectionId) {
        this.sectionId = this.grade.sections.map((item) => {
          return item.id;
        }).join(',');
      }

      let extraParam = `fromDate=${this.frmDate}&cutoff=${this.cutOffDate}&gradeId=${this.gradeId}&sectionId=${this.sectionId}&filter_type=${this.report_type}`;
      this.loading = true;
      this.totalSum = 0;

      this.$restV2(v2Services.BILLING).get(`/v2/as-of-due?${extraParam}`).then((response) => {
        this.records = response.data;
        response.data.map((item) => {
          this.totalSum += parseFloat(item.due_as_of);
        });
      }).finally(() => {
        this.loading = false;
      });
    },

  },
};
</script>
<style lang="scss"></style>
